export interface NotificationResponse {
  event: string;
  data: {
    user: string;
    tokensBought: string;
    amountPaid: string;
    usdEq: string;
    isNativeToken: boolean;
    timestamp: string;
    projectName: string;
    slug: string;
    chain: string;
    transactionHash: string;
    explorerUrl: string;
  };
  timestamp: string;
}

export const ServerSentEvents = {
  BOUGHT: 'TokensBought',
  BOUGHT_AND_STAKED: 'TokenBoughtAndStaked',
  CLAIMED: 'TokensClaimed',
  CLAIMED_AND_STAKED: 'TokensClaimedAndStaked',
};

export const TxnTypes: any = {
  TokensBought: 'Bought',
  TokensBoughtAndStaked: 'Bought and Staked',
  TokensClaimed: 'Claimed',
  TokensClaimedAndStaked: 'Claimed and Staked',
};
